module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications-template-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Notifications Template',
          to: {
            path: '/notifications-template'
          },
        },
        {
          text: !_vm.$route.query.id ?
            'Tambah Notifikasi' :
            'Ubah Notifikasi',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah Notifikasi" : "Ubah Notifikasi") + "\n    ")]), _vm._v(" "), _c('div', [_c('v-card', {
    staticClass: "d-flex",
    attrs: {
      "flat": ""
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-card', {
    staticClass: "border-bottom-divider rounded-tl pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.form.img_url ?
        _vm.form.img_url :
        require('@/assets/img/unavailable.png')
    }
  })])])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-btn', {
    staticClass: "pa-0 font-weight-bold dark--text",
    attrs: {
      "block": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.uploader.click()
      }
    }
  }, [_vm._v("\n                            Upload *\n                        ")]), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "id": "notification_image",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center"
  }, [_vm._v("\n                        Rasio thumbnail foto 16:9\n                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center"
  }, [_vm._v("\n                        Maximum size is 200 KB\n                    ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "border-left": "1px solid #f0f0f0"
    },
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Title *\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Judul Notifikasi",
      "outlined": ""
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Body *\n                                ")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "placeholder": "Body Notifikasi",
      "outlined": ""
    },
    model: {
      value: (_vm.form.body),
      callback: function($$v) {
        _vm.$set(_vm.form, "body", $$v)
      },
      expression: "form.body"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "px-0 pt-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Feature *\n                                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "outlined": "",
      "placeholder": "Pilih Feature",
      "items": _vm.featureList,
      "item-text": "feature_name",
      "item-value": "id"
    },
    model: {
      value: (_vm.form.feature),
      callback: function($$v) {
        _vm.$set(_vm.form, "feature", $$v)
      },
      expression: "form.feature"
    }
  })], 1)], 1), _vm._v(" "), [_c('v-btn', {
    staticClass: "white--text blew",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.openFormFeature()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                                Feature\n                            ")], 1)], _vm._v(" "), _c('v-list-item', {
    staticClass: "pt-6 pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Webapp Link *\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Judul Tryout",
      "outlined": ""
    },
    model: {
      value: (_vm.form.webapp_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "webapp_link", $$v)
      },
      expression: "form.webapp_link"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Android Link *\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Judul Tryout",
      "outlined": ""
    },
    model: {
      value: (_vm.form.android_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "android_link", $$v)
      },
      expression: "form.android_link"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    iOs Link *\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Judul Tryout",
      "outlined": ""
    },
    model: {
      value: (_vm.form.ios_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "ios_link", $$v)
      },
      expression: "form.ios_link"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "depressed": "",
      "color": "blew",
      "id": "notifikasi_simpan"
    },
    on: {
      "click": function($event) {
        return _vm.putObject()
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "800px",
      "height": "200px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.featureModal = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', {
          staticClass: "d-flex",
          attrs: {
            "width": "100%"
          }
        }, [_vm._v("\n                    Tambah Feature\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
          staticClass: "px-6",
          attrs: {
            "width": "100%"
          }
        }, [_c('v-list-item', {
          attrs: {
            "two": "",
            "line": ""
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-bold pb-2"
        }, [_vm._v("\n                                Service\n                            ")]), _vm._v(" "), _c('v-select', {
          staticClass: "pa-0",
          attrs: {
            "outlined": "",
            "placeholder": "Pilih Service",
            "items": _vm.serviceList,
            "item-text": "service_name",
            "item-value": "id"
          },
          model: {
            value: (_vm.featureForm.service_id),
            callback: function($$v) {
              _vm.$set(_vm.featureForm, "service_id", $$v)
            },
            expression: "featureForm.service_id"
          }
        })], 1)], 1), _vm._v(" "), _c('v-list-item', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "pa-0"
        }, [_c('v-list-item-title', {
          staticClass: "font-weight-bold pb-2"
        }, [_vm._v("\n                                Feature Name *\n                            ")]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "placeholder": "Nama Feature",
            "outlined": ""
          },
          model: {
            value: (_vm.featureForm.feature_name),
            callback: function($$v) {
              _vm.$set(_vm.featureForm, "feature_name", $$v)
            },
            expression: "featureForm.feature_name"
          }
        })], 1)], 1), _vm._v(" "), _c('v-list-item', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "pa-0"
        }, [_c('v-list-item-title', {
          staticClass: "font-weight-bold"
        }, [_vm._v("\n                                Redis Code *\n                            ")]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "placeholder": "Redis Code",
            "outlined": ""
          },
          model: {
            value: (_vm.featureForm.redis_code),
            callback: function($$v) {
              _vm.$set(_vm.featureForm, "redis_code", $$v)
            },
            expression: "featureForm.redis_code"
          }
        })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "dark": "",
            "color": "blew"
          },
          on: {
            "click": function($event) {
              return _vm.addNewFeature()
            }
          }
        }, [_vm._v("Simpan")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.featureModal),
      callback: function($$v) {
        _vm.featureModal = $$v
      },
      expression: "featureModal"
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73585eee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/notifications_template/components/NotificationsTemplateForm.vue
// module id = 1908
// module chunks = 1